//import React from 'react';
import {store} from './Redux/store'

class initialStore {
    dispatch() {
        console.log('fake dispatch')
    }
    subscribe() {}
}

let _store = store;
let _domain = '';
let _environment = 'prod';

export const config = {
    setValues: ({store, domain, environment}) => {
        _environment = environment;
        _domain = domain;
        _store = store;
    },
    setDomain: domain => _domain = domain,
    getDomain: () => {
        return _domain;
    },
    setEnvironment: environment => _environment = environment,
    getEnvironment: () => {
        return _environment;
    },
    setStore: store => _store = store,
    getStore: () => {
        return _store;
    },
    getUrl: (subdomain, protocol = 'https://') => {
        return protocol + subdomain + '.' + _domain;
    },
    getAdminUrl: (protocol = 'https://') => {
        return config.getUrl('admin', protocol);
    },
    getApiUrl: (protocol = 'https://') => {
        return config.getUrl('api', protocol);
    },
    getLibraryUrl: (protocol = 'https://') => {
        return config.getUrl('library', protocol);
    },
    getMonitoringUrl: (protocol = 'https://') => {
        return config.getUrl('monitoring', protocol);
    }
};

Object.freeze(config);

